/*
 * @Author: sfy
 * @Date: 2023-05-09 10:31:09
 * @LastEditors: sfy
 * @LastEditTime: 2023-05-09 10:32:17
 * @FilePath: /lcp-asset/packages/lcp-pro/src/utils/envTools.ts
 * @Description: update here
 */
// 备注：钉钉h5开发，根据dingtalk-jsapi可以判断当前是否是在钉钉环境，也可以通过粗暴的报错去判断；
import * as dd from 'dingtalk-jsapi'
export const getDingEnvPlatform = () => { /* 判断是否钉钉环境 */
  if (dd.env.platform === 'notInDingTalk') {
    return false
  }
  return true
}